import React from 'react';

function About() {


    return (
        <div className='tictactoe-wrapper'>
            <h1> SHLOMI IS GAY! </h1>
        </div>
    );
}

export default About;
